const featureToggles = {
  // Allow-list of user IDs who see gated features.
  featureFlagOverrideUserIds: [2, 341236],

  // Pitch limit A/B/C test: variant b = 1/day, c = 5/month.
  // Set to true when the test is ready to go live.
  pitchLimitAbcTest: true,
};

export default featureToggles;
